 
import { type Pharmacy, type PharmacyFilter } from '../../../../../../../../types/types'
import { apiCall } from '../../../../../../../../utils/restclient'

export const pharmacyFilters = [
  { name: 'EPCS', isActive: true, paramName: 'IsEpcsEnabled', disabled: true },
  { name: '24/7', isActive: false, paramName: 'Is24Hrs', disabled: false },
  { name: 'Retail', isActive: false, paramName: 'IsRetailStore', disabled: false },
]
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const adaptationSymbolsForAPI = (textValue) =>
  encodeURIComponent(textValue).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`)

export async function searchPharmacies(
  patientId: string,
  searchValue: string,
  filters: PharmacyFilter[],
): Promise<Pharmacy[] | void> {
  const params = new URLSearchParams('')

  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  if (!filters[0].isActive) {
    for (let i = 1; i < filters.length; i++) {
      // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
      if (filters[i].isActive) {
        // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
        params.set(filters[i].paramName, filters[i].isActive.toString())
      }
    }
  }
  const query = params.toString()
  const data = await apiCall(
    `api/v1/pharmacies?PatientId=${patientId}&Count=10${searchValue ? `&SearchValue=${searchValue}` : ''}${
      query ? `&${query}` : ''
    }`,
    'GET',
  )
    // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
    .then((result: Pharmacy[]) => result)
    .catch((e) => {
      throw e
    })
  return data
}
